import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector, useChatWidget } from "../../../../shared/model";
import { selectIsChatOpen, setChatOpen as setOpen } from "../../../../entities/settings/model";

/**
 * @param shouldOpen - флаг который передается в виджет из вне
 */
export var useChatOpen = function useChatOpen(shouldOpen) {
  var _useChatWidget = useChatWidget(),
    _useChatWidget2 = _slicedToArray(_useChatWidget, 3),
    isOpen = _useChatWidget2[0],
    setIsOpen = _useChatWidget2[1],
    exist = _useChatWidget2[2];
  var isChatOpen = useAppSelector(selectIsChatOpen);
  var dispatch = useAppDispatch();
  var setChatOpen = function setChatOpen(flag) {
    return dispatch(setOpen(flag));
  };
  useEffect(function () {
    setIsOpen(isChatOpen);
  }, [isChatOpen]);
  useEffect(function () {
    if (exist) {
      setChatOpen(isOpen);
    }
  }, [isOpen]);
  useEffect(function () {
    if (typeof shouldOpen === 'boolean') {
      setIsOpen === null || setIsOpen === void 0 || setIsOpen(shouldOpen);
      setChatOpen(shouldOpen);
    }
  }, [shouldOpen]);
};